export function updateJobs(data) {
    var jobs = [],
        categories = ["Conseil", "Création", "Technique / Dev"];
    for (var categoryId in categories) {
        var category = categories[categoryId];
        for (var jobId in data[category]) {
            var job = data[category][jobId];
            jobs[job.id] = {
                id: job.id,
                titre: job.titre,
                profil: job.profil,
                experience: job.experience,
                tjm_ht: job.tjm_ht,
                categoryId: parseInt(categoryId) + 1, 
                nbjours: 0
            };
        }
    }
    return jobs;
}

export function getDevice() {
    return window.innerWidth < 767 ? 'mobile' : window.innerWidth < 1025 ? 'tablet' : 'desktop';
}

export function formatNumber(nb) {
    return nb < 1000 ?
        nb + ' €' : 
        nb.substring(0, nb.length - 3) + ' ' + nb.substring(nb.length - 3) + ' €'
}

export function formatProfil(experience, profil) {
    return '<strong>Profil :</strong> ' + experience + '. ' +
            profil.replace('Intervient sur :', '<strong>Intervient sur :</strong>')
                .replace('Interagit avec :', '<strong>Interagit avec :</strong>');
}

export function formatProfilIntervention (profil) {
    return profil.substring(0, profil.indexOf('Interagit avec :') - 2).replace('Intervient sur :', '<strong>Intervient sur :</strong>')
}

export function formatProfilInteraction (profil) {
    return profil.substring(profil.indexOf('Interagit avec :')).replace('Interagit avec :', '<strong>Interagit avec :</strong>')
}